import { useSearchParams } from 'react-router-dom'

type CashfitParams<T> = {
  page: number
  totalPages: number
  pageSize: number
  totalContents: number
  tabSelected: keyof T
  tabContentId: string
  formId: string
  unit: string
  navId: string
  tabProductId: string
  tabServiceId: string
  tabPlanId: string
  sheetId: string
  studentId: string
  traningId: string,
  nameStudent: string,
}

export const convertParamsToJson = (params: any) => {
  const paramsParsed: any = {}
  params.forEach((value: any, key: any) => {
    paramsParsed[key] = value
  })
  return paramsParsed
}

export function useCashfitParams<T>(defaultValue: any) {
  type Params = keyof CashfitParams<T>

  const [searchParams, setParamsUrl] = useSearchParams(defaultValue)

  const setParams = (params: Partial<CashfitParams<T>>) => {
    setParamsUrl({ ...convertParamsToJson(searchParams), ...params } as any)
  }

  const removeParam = (param: Params) => {
    searchParams.delete(param as string)
    setParamsUrl(searchParams)
  }

  const getParam = (param: Params) => searchParams.get(param as string)

  return {
    removeParam,
    setParams,
    getParam
  }
}
